module.exports = __webpack_public_path__ + "static/media/Heartsick.7fb734ae.jpg";